import { FILTER_SIDEBAR_FIELD_SURFACE_DEFAULTS } from './fieldSurfaces/filterSidebarSurface'
import type { FieldSurface } from './fieldSurfaces/types'

/** Surface cho sidebar filter — truyền vào `TextInput` / `SelectInput`. */
export const FILTER_SIDEBAR_SURFACE = 'filterSidebar' as const satisfies FieldSurface

/** Surface cho header / popover toolbar filter. */
export const FILTER_TOOLBAR_SURFACE = 'filterToolbar' as const satisfies FieldSurface

/** Surface ô nhập màn POS bán hàng — tách base khỏi form admin. */
export const POS_FIELD_SURFACE = 'pos' as const satisfies FieldSurface

/** Surface cột 2 POS (giao hàng) — chỉ gạch chân. */
export const POS_UNDERLINE_FIELD_SURFACE = 'posUnderline' as const satisfies FieldSurface

/** @deprecated — dùng `surface={FILTER_SIDEBAR_SURFACE}`; size lấy từ `filterSidebarSurface`. */
export const FILTER_FIELD_SIZE = FILTER_SIDEBAR_FIELD_SURFACE_DEFAULTS.size
